import http, { authHeader } from './http';

// Получить опубликованные посты
export const getPosts = (token) =>
  http.get('/api/news', { headers: authHeader(token) }).then((r) => r.data);

// Получить комментарии к посту
export const getComments = (token, postId) =>
  http.get(`/api/news/${postId}/comments`, { headers: authHeader(token) }).then((r) => r.data);

// Добавить комментарий
export const addComment = (token, postId, content) =>
  http.post(`/api/news/${postId}/comments`, { content }, { headers: authHeader(token) }).then((r) => r.data);

// Удалить комментарий
export const deleteComment = (token, postId, commentId) =>
  http.delete(`/api/news/${postId}/comments/${commentId}`, { headers: authHeader(token) }).then((r) => r.data);

// --- Admin-функции ---

// Получить все посты (включая черновики)
export const getAllPostsAdmin = (token) =>
  http.get('/api/admin/news', { headers: authHeader(token) }).then((r) => r.data);

// Создать пост (поддержка FormData для загрузки изображений)
export const createPost = (token, data) =>
  http.post('/api/news', data, { headers: authHeader(token) }).then((r) => r.data);

// Обновить пост (поддержка FormData для загрузки изображений)
export const updatePost = (token, id, data) =>
  http.put(`/api/news/${id}`, data, { headers: authHeader(token) }).then((r) => r.data);

// Удалить пост
export const deletePost = (token, id) =>
  http.delete(`/api/news/${id}`, { headers: authHeader(token) }).then((r) => r.data);
